<template>
  <div class="customer-updates">
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Updates to Customers
      <div slot="right" class="navbar-message button-gap-right-aligned">
        <b-button
          type="is-success"
          class="import-button"
          @click="saveMessage('done')"
          >Save</b-button
        >
        <b-button
          type="is-normal"
          class="import-button"
          @click="saveMessage('draft')"
          >Save as draft</b-button
        >

        <b-button
          slot="right"
          class="import-button"
          type="is-primary"
          @click="$router.go(-1)"
        >
          <span>Back</span>
        </b-button>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column">
          <b-field label="Subject">
            <b-input required name="subject" expanded v-model="subject">
            </b-input>
          </b-field>

          <b-field label="Update for Customers">
            <vue-editor
              v-model="message"
              required
              expanded
              placeholder="Input update for customers"
              :editor-toolbar="editorToolbar"
            />
          </b-field>
          <b-field label="Attachment">
            <b-upload v-model="attachment" class="file-label" multiple drag-drop
              ><span>
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"> </b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section></span
              >
            </b-upload>
          </b-field>
          <div class="tags">
            <span
              v-for="(file, index) in attachment"
              :key="index"
              class="tag is-primary download-document"
            >
              <span>
                {{ file.name }}
              </span>
              <button
                class="delete is-small"
                type="button"
                @click="deleteFromFile(index)"
              ></button>
            </span>
          </div>
          <b-field label="Update Type">
            <b-select
              required
              placeholder="Select update type"
              v-model="updateType"
              expanded
            >
              <option value="reporting" key="1">Reporting Updates</option>
              <option value="regulatory" key="2">Regulatory Updates</option>
            </b-select>
          </b-field>
          <b-field label="Recipient Type" @change="switchOptions">
            <b-select
              required
              placeholder="Select a recipient type"
              v-model="recipientType"
              @input="switchOptions"
              expanded
            >
              <option value="country" key="4">Country</option>
              <option value="scheme" key="1">Scheme</option>
              <option value="stream" key="3">Stream</option>
              <option value="customer" key="2">Customer</option>
            </b-select>
          </b-field>

          <b-field v-if="recipientType == 'customer'" label="Customers">
            <multiselect
              ref="multiselect"
              v-model="selectedCustomers"
              :options="filteredTags"
              placeholder="Select"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              @search-change="getFilteredTags"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :class="{ 'background-inactive': !scope.option.active }"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
          <b-field v-if="recipientType == 'country'" label="Countries">
            <b-select
              multiple
              placeholder="Select countries"
              v-model="selectedCountries"
              expanded
              @input="updateCustomers"
            >
              <option
                v-for="(option, index) in countries"
                :value="option.id"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field v-if="recipientType == 'scheme'" label="Schemes">
            <b-select
              multiple
              placeholder="Select schemes"
              v-model="selectedSchemes"
              @input="updateCustomers"
              expanded
            >
              <option
                v-for="(option, index) in schemes"
                :value="option.id"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field
            v-if="
              recipientType == 'stream' ||
                recipientType == 'scheme' ||
                recipientType == 'country'
            "
            label="Streams"
          >
            <b-select
              expanded
              multiple
              placeholder="Select streams"
              v-model="selectedStreams"
              @input="updateCustomers"
            >
              <option
                v-for="(option, index) in containers"
                :value="option.id"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field
            v-if="recipientType !== 'customer'"
            label="Customer Type"
            placeholder="Select customer type"
          >
            <b-select
              placeholder="Select customer type"
              v-model="selectedCustomerType"
              @input="updateCustomers"
              expanded
              >4
              <option
                v-for="(option, index) in allCustomerTypes"
                :value="option"
                :key="index"
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>

          <b-field
            v-if="recipientType !== 'customer'"
            label="Landbell Entity"
            placeholder="Select landbell entity"
          >
            <b-select
              multiple
              placeholder="Select landbell entity"
              v-model="selectedLandbellEntity"
              @input="updateCustomers"
              expanded
            >
              <option
                v-for="(option, index) in allLandbellEntities"
                :value="option"
                :key="index"
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>

          <b-field
            v-if="recipientType !== 'customer'"
            label="Customers"
            class="taginput-fix-height"
          >
            <multiselect
              ref="multiselect"
              v-model="selectedCustomers"
              :options="filteredTags"
              placeholder="Select"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              @search-change="getFilteredTags"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :class="{ 'background-inactive': !scope.option.active }"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="true">
    </b-loading>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import ScopeMixin from "@/mixins/scopeMixin";
import { Permission } from "../../services/Permissions";
import SchemeDataService from "../../services/SchemeDataService";
import StreamDataService from "../../services/ContainerDataService";
import CountryDataService from "../../services/CountryDataService";
import CustomerUpdatesDataService from "../../services/CustomerUpdatesDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Multiselect from "vue-multiselect";
export default {
  name: "CustomerUpdatesAdd",
  components: { HeroBar, TitleBar, Multiselect, VueEditor },
  mixins: [ScopeMixin],
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),

    titleStack() {
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        { url: "/reportingtracker/add", name: "Updates to Customers" }
      ];
    }
  },
  data() {
    return {
      isModalActive: false,
      schemeDataService: new SchemeDataService(),
      streamDataService: new StreamDataService(),
      countryDataService: new CountryDataService(),
      customerDataService: new CustomerProfileDataService(),
      customerUpdatesDataService: new CustomerUpdatesDataService(),

      updateCreated: false,
      isComponentModalActive: true,
      subject: null,
      message: null,
      updateType: null,
      attachment: null,
      recipientType: null,
      messageStatus: null,
      customerUpdate: null,
      customerUpdateId: null,
      isLoading: false,
      schemes: [],
      scopes: [],
      streams: [],
      trackers: [],
      contacts: [],
      countries: [],
      customers: [],
      customerUpdates: [],
      selectedSchemes: [],
      selectedStreams: [],
      selectedCustomerType: "All",
      selectedLandbellEntity: [],
      selectedCountries: [],
      selectedCustomers: [],
      selectedCustomerIds: [],
      filteredTags: [],
      allCustomerTypes: {
        all: "All",
        small: "Small Customer",
        large: "Large Customer",
        europlus_small: "Small - EuropePlus Customer",
        flat_rate_small: "Small - Flat Rate Customer"
      },
      allLandbellEntities: {
        " ": " ",
        H2C: "H2C",
        SAS: "SAS",
        LB: "LB",
        UK: "UK",
        Topengi: "Topengi",
        "Amazon Marketplace": "Amazon Marketplace",
        "General Marketplace": "General Marketplace",
        "ERP UK": "ERP UK"
      },
      editorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ color: [] }]
      ]
    };
  },
  mounted() {
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchCountries();
    this.fetchCustomerProfileData();
    this.getFilteredTags();
    this.fetchScopes();
  },
  ready() {
    this.fetchCustomerProfileData();
    this.fetchContainers();
  },
  methods: {
    fetchScopes() {
      this.customerUpdatesDataService.getCustomerScopes().subscribe(
        response => {
          this.scopes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    showConvertedMessage() {
      const objAsHtml = "<div>" + this.message + "</div>";
      this.$buefy.dialog.alert({
        title: "Update for customers",
        message: objAsHtml
      });
    },
    updateCustomers() {
      let selCustomers = null;
      let customerIds = null;
      if (this.recipientType == "scheme") {
        if (this.selectedStreams.length > 0) {
          selCustomers = this.customers.filter(data => {
            const scopes = data.scope_scheme.filter(schemeId => {
              return this.selectedSchemes.includes(parseInt(schemeId));
            });
            return scopes && scopes.length > 0;
          });

          selCustomers = selCustomers.filter(data => {
            const streams = data.scope_stream.filter(streamId => {
              return this.selectedStreams.includes(parseInt(streamId));
            });
            return streams && streams.length > 0;
          });
        } else {
          selCustomers = this.customers.filter(data => {
            const scopes = data.scope_scheme.filter(schemeId => {
              return this.selectedSchemes.includes(parseInt(schemeId));
            });
            return scopes && scopes.length > 0;
          });
        }
        customerIds = selCustomers.map(a => a.id);
      } else if (this.recipientType == "stream") {
        selCustomers = this.customers.filter(data => {
          const scopes = data.scope_stream.filter(streamId => {
            return this.selectedStreams.includes(parseInt(streamId));
          });
          return scopes && scopes.length > 0;
        });
        customerIds = selCustomers.map(a => a.id);
      } else if (this.recipientType == "country") {
        selCustomers = this.scopes.filter(
          scope =>
            this.selectedCountries.includes(scope.country) &&
            this.selectedStreams.includes(scope.stream)
        );
        customerIds = selCustomers.map(a => a.customer);
      }
      if (this.selectedCustomerType != "All") {
        const filteredCustomers = this.customers.filter(data =>
          customerIds.includes(data.id)
        );
        selCustomers = filteredCustomers.filter(
          data => data.customer_type == this.selectedCustomerType
        );
        customerIds = selCustomers.map(a => a.id);
      }

      if (this.selectedLandbellEntity.length != 0) {
        const filteredCustomers = this.customers.filter(data =>
          customerIds.includes(data.id)
        );
        selCustomers = filteredCustomers.filter(data =>
          this.selectedLandbellEntity.includes(data.landbell_entity)
        );
        customerIds = selCustomers.map(a => a.id);
      }

      this.selectedCustomers = this.customers.filter(item =>
        customerIds.includes(item.id)
      );
      this.selectedCustomerIds = this.selectedCustomers.map(a => a.id);
    },

    routeToCustomerUpdateEdit(updateId) {
      this.$router.push({
        name: "reportingtracker.customerUpdateEdit",
        params: {
          id: updateId
        },
        query: { plan: "start" }
      });
    },

    isAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return false;
    },
    saveMessage(status) {
      this.isLoading = true;
      let msg = "Following fields are mandatory <br/><br/>";
      if (this.subject == null || this.subject == "") {
        msg += " -  Subject <br/>";
      }
      if (this.message == null || this.message == "") {
        msg += " -  Message <br/>";
      }
      if (this.updateType == "" || this.updateType == null) {
        msg += " -  Update Type <br/>";
      }
      if (this.recipientType == "" || this.recipientType == null) {
        msg += " -  Recipient Type <br/>";
      }
      if (
        this.recipientType != "customer" &&
        this.selectedLandbellEntity.length == 0
      ) {
        msg += " -  Landbell Entity <br/>";
      }

      // Check attachment size - limit is 20MB
      if (this.attachment && Array.isArray(this.attachment)) {
        const totalSize = this.attachment.reduce(
          (sum, file) => sum + (file.size || 0),
          0
        );
        const maxSize = 20 * 1024 * 1024; // 20MB in bytes

        if (totalSize > maxSize) {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Please reduce attachment size. Limit is 20MB.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          this.isLoading = false;
          return -1;
        }
      } else if (this.attachment && this.attachment.size) {
        const maxSize = 20 * 1024 * 1024; // 20MB in bytes

        if (this.attachment.size > maxSize) {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Please reduce attachment size. Limit is 20MB.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          this.isLoading = false;
          return -1;
        }
      }

      if (
        this.message == null ||
        this.subject == null ||
        this.message == "" ||
        this.subject == "" ||
        this.updateType == "" ||
        this.updateType == null ||
        this.recipientType == "" ||
        this.recipientType == null ||
        (this.recipientType != "customer" &&
          this.selectedLandbellEntity.length == 0)
      ) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: msg,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        this.isLoading = false;
        return -1;
      } else {
        this.messageStatus = status;
        const contactIds = this.contacts.map(a => a.id);
        let fileName = null;
        if (this.attachment) {
          fileName = this.attachment.name;
        } else {
          fileName = this.attachment;
        }
        let selectedCustomerstoSent = null;

        this.selectedCustomerIds = this.selectedCustomers.map(a => a.id);
        selectedCustomerstoSent = this.selectedCustomerIds;

        const payload = {
          status: status,
          attachment: fileName,
          contacts: contactIds,
          subject: this.subject,
          message: this.message,
          id: this.customerUpdateId,
          schemes: this.selectedSchemes,
          streams: this.selectedStreams,
          recipient_type: this.recipientType,
          customer_type: this.selectedCustomerType,
          landbell_entity: this.selectedLandbellEntity,
          update_type: this.updateType,
          customers: selectedCustomerstoSent,
          countries: this.selectedCountries
        };
        this.customerUpdatesDataService
          .post(payload, this.attachment)
          .subscribe(response => {
            this.updateCreated = true;
            this.isLoading = false;
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Customer Update Created!",
              onConfirm: () => this.routeToCustomerUpdateEdit(response.id)
            });
          }, this.handleApiError);
      }
    },
    cancelMessage() {
      this.subject = null;
      this.message = null;
      this.attachment = {};
      this.recipientType = null;
      this.updateType = null;
      this.selectedSchemes = [];
      this.selectedStreams = [];
      this.selectedCustomerType = [];
      this.selectedLandbellEntity = [];
      this.selectedCustomers = [];
      this.selectedCountries = [];
    },

    switchOptions() {
      if (this.recipientType == "scheme") {
        this.selectedCustomers = [];
        this.selectedCountries = [];
        this.selectedStreams = [];
        this.selectedCustomerType = "All";
        this.selectedLandbellEntity = [];
        this.fetchSchemes();
      } else if (this.recipientType == "customer") {
        this.selectedSchemes = [];
        this.selectedStreams = [];
        this.selectedCountries = [];
        this.selectedCustomerType = "All";
        this.selectedLandbellEntity = [];

        this.fetchCustomerProfileData();
      } else if (this.recipient_type == "country") {
        this.selectedCustomers = [];
        this.selectedSchemes = [];
        this.selectedStreams = [];
        this.selectedCustomerType = "All";
        this.selectedLandbellEntity = [];

        this.fetchCountries();
      } else if (this.recipient_type == "stream") {
        this.selectedCustomers = [];
        this.selectedSchemes = [];
        this.selectedCountries = [];
        this.selectedCustomerType = "All";
        this.selectedLandbellEntity = [];

        this.fetchContainers();
      } else {
        this.selectedCustomers = [];
        this.selectedSchemes = [];
        this.selectedStreams = [];
        this.selectedCountries = [];
        this.selectedCustomerType = "All";
        this.selectedLandbellEntity = [];
      }
    },
    deleteFromFile(index) {
      this.attachment.length > 0 && this.attachment.splice(index, 1);
    },
    fetchCustomerProfileData() {
      this.customerDataService.getCustomerList().subscribe(
        response => {
          this.customers = response;
          this.customers = this.customers.filter(function(obj) {
            return obj.active == true && obj.operational == true;
          });

          this.customers.sort(function(a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          });
          this.filteredTags = this.customers;
        },
        e => {
          console.log(e);
        }
      );
    },

    getFilteredTags(text) {
      this.filteredTags = this.customers.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    handleApiError(reason) {
      this.isLoading = false;
      let errorMessage = undefined;
      if (
        reason.response.status == 403 &&
        reason.response.data.code == "token_not_valid"
      ) {
        alert("Session expired, please login again");
        this.authService.logout(this.$keycloak);
        return;
      }
      try {
        errorMessage = reason.response.data["detail"];
      } catch (error) {
        errorMessage = reason.response.data["name"][0];
      } finally {
        errorMessage = reason.response.data["detail"];

        if (errorMessage == null || errorMessage == undefined) {
          errorMessage = "Invalid input";
        }
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
      return -1;
    }
  }
};
</script>
